import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClienteDetalharJanelaRoutingModule } from './cliente-detalhar-janela-routing.module';
import { ClienteDetalharJanelaComponent } from './cliente-detalhar-janela.component';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    ClienteDetalharJanelaComponent
  ],
  imports: [
    CommonModule,
    ClienteDetalharJanelaRoutingModule,
    TableModule,
    DividerModule,
    MessagesModule,
    FormatPipeModule,
    ProgressSpinnerModule
  ]
})
export class ClienteDetalharJanelaModule { }
